import { ChevronDown } from 'lucide-react';
import { RefObject, useCallback } from 'react';

import { useIsMobile } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';

type Props = {
  scrollRef: RefObject<HTMLDivElement>;
};

export default function MouseScrollIndicator({ scrollRef }: Props) {
  const isMobile = useIsMobile();

  const scrollToTheBottom = useCallback(() => {
    // On mobile, #root is the scroll container due to CSS
    const rootElement = document.getElementById('root');
    const scrollTarget = isMobile && rootElement ? rootElement : scrollRef.current;

    if (scrollTarget) {
      scrollTarget.scrollTo({
        top: scrollTarget.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [scrollRef, isMobile]);

  return (
    <button
      className={cn(
        'flex animate-slide-in-top items-center justify-center rounded-full bg-livelinx-orange200 font-bold opacity-0 delay-1000 duration-1000'
      )}
      onClick={scrollToTheBottom}
      aria-label="Scroll to bottom"
    >
      <ChevronDown className="my-2 size-10 bg-transparent text-white" />
    </button>
  );
}
